// Catering KDS Config Related Enums

import { CateringOrderStatus, ICateringOrder } from './cateringOrder.types';

// KDS Config Type Enum
export enum KdsConfigType {
  AUTOMATIC = 'Automatic',
  MANUAL = 'Manual',
}

// Trigger Days Enum
export enum TriggerDays {
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
}

// KDS Config Status Enum
export enum KdsConfigStatus {
  SCHEDULED = 'scheduled',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export interface ISendToKdsRequest {
  cateringOrderId: string;
}

export interface IKdsFulfillRequest {
  cateringOrderId: string;
}

export interface ICateringKdsConfig {
  id: number;
  cateringOrderId: string;
  sendDate?: Date;
  type: KdsConfigType;
  triggerDays?: TriggerDays;
  status: KdsConfigStatus;
  errorMessage?: string;
  createdAt: Date;
  updatedAt: Date;
  cateringOrder: ICateringOrder;
}

export interface IKdsConfigRequest {
  cateringOrderId: string;
  type: KdsConfigType;
  triggerDays?: TriggerDays;
}

export interface IUpdateStatusRequest {
  cateringOrderId: string;
  orderStatus: CateringOrderStatus;
}

export interface IKdsConfigRequestEventBridge {
  id: number;
  eventName: string;
  restaurantId: number;
  businessId: number;
  time: string;
  date: string;
  timezone: string;
}
